import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { States } from '../../helpers/constants';

import { createAccount } from '../../actions/app/app';
import { hideModal } from '../../actions/modal/modal';

const SignUpForm = props => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        formik = useFormik({
          initialValues: {
            email: "",
            confirmEmail: "",
            password: "",
            confirmPassword: "",
            phone: "",
            postal_address: "",
            postal_suburb: "",
            postal_state: "QLD",
            postal_code: "",
            group_name: "",
            first_name: "",
            last_name: "",
            is_admin: false,
            is_akfstaff: false,
            is_licenseduser: false
            //user_name: ''
          },
          validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Email address is required'),
            confirmEmail: Yup.string().email('Invalid email address').required('Confirm email address is required').test('match', 
              'Email addresses do not match', 
              function (confirmEmail) { return confirmEmail === this.parent.email }),
            password: Yup.string().min(8, 'Password must contain at least 8 characters').required('Password is required'),
            confirmPassword: Yup.string().required('Confirm password is required').test('match',
              'Passwords do not match.',
              function (confirmPassword) { return confirmPassword === this.parent.password }),
            phone: Yup.string().matches(/^\d+$/, 'Phone number can only contain numbers'),
            postal_address: Yup.string(),
            postal_suburb: Yup.string(),
            postal_state: Yup.string(),
            postal_code: Yup.string().matches(/^\d+$/, 'Postal code can only contain numbers'),
            group_name: Yup.string(),
            first_name: Yup.string().required('First name is required'),
            last_name: Yup.string().required('Surname is required')
            //user_name: Yup.string().matches(/^[A-Za-z0-9]+$/, 'Username can only contain letters and numbers').required('A username is required')
          }),
          onSubmit: values => {

            const form = JSON.stringify({
              phone: values.phone,
              postal_address: values.postal_address,
              postal_suburb: values.postal_suburb,
              postal_state: values.postal_state,
              postal_code: values.postal_code === '' ? null : values.postal_code,
              group_name: values.group_name,
              user: {
                first_name: values.first_name,
                last_name: values.last_name,
                password: values.password,
                email: values.email,
                //username: values.user_name
              },
              is_admin: values.is_admin === 'true' ? true : false,
              is_akfstaff: values.is_akfstaff === 'true' ? true : false,
              is_licenseduser: values.is_licenseduser === 'true' ? true : false
            });

            dispatch(createAccount(form));
          }
        }),
        isAdmin = appProps.loggedInUser?.is_admin;

  const _modalClose = () => {
    if (!formik.dirty) return dispatch(hideModal());
      
    if (!window.confirm('You have unsaved changes. Closing will lose any changes.\nAre you sure you wish to close?')) return false;

    dispatch(hideModal());
  }

  return (
    <>
      <span className="modal__close" onClick={ () => _modalClose() }>&times;</span>
      
      <form onSubmit={ formik.handleSubmit } className="form form--restricted">
        <div className="form__group">
          <label className="form__label">Account information</label>
          {/* <input className="form__input" type="text" value={ formik.values.user_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="user_name" id="user_name" placeholder="Enter a username" />
          { formik.touched.user_name && formik.errors.user_name ? (<span className="form__error-item">{ formik.errors.user_name }</span>) : ''} */}
          <input className="form__input" type="email" value={ formik.values.email } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="email" id="email" placeholder="Email address" />
          { formik.touched.email &&  formik.errors.email ? (<span className="form__error-item">{ formik.errors.email }</span>) : ''}
          <input className="form__input" type="email" value={ formik.values.confirmEmail } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="confirmEmail" id="confirmEmail" placeholder="Confirm email address" />
          { formik.touched.confirmEmail &&  formik.errors.confirmEmail ? (<span className="form__error-item">{ formik.errors.confirmEmail }</span>) : ''}
        </div>

        <div className="form__group">
          <label className="form__label">Your information</label>
          <input className="form__input" type="text" value={ formik.values.first_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="first_name" id="first_name" placeholder="First name" />
          { formik.touched.first_name && formik.errors.first_name ? (<span className="form__error-item">{ formik.errors.first_name }</span>) : ''}
          <input className="form__input" type="text" value={ formik.values.last_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="last_name" id="last_name" placeholder="Surname" />
          { formik.touched.last_name && formik.errors.last_name ? (<span className="form__error-item">{ formik.errors.last_name }</span>) : ''}
          <input className="form__input" type="tel" value={ formik.values.phone } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="phone" id="phone" placeholder="Phone number" />
          { formik.touched.phone && formik.errors.phone ? (<span className="form__error-item">{ formik.errors.phone }</span>) : ''}
        </div>

        <div className="form__group">
          <label className="form__label">Password</label>
          <input className="form__input" type="password" value={ formik.values.password } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="password" id="password" placeholder="Password" />
          { formik.touched.password && formik.errors.password ? (<span className="form__error-item">{ formik.errors.password }</span>) : ''}
          <input className="form__input" type="password" value={ formik.values.confirmPassword } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="confirmPassword" id="confirmPassword" placeholder="Confirm Password" />
          { formik.touched.confirmPassword && formik.errors.confirmPassword ? (<span className="form__error-item">{ formik.errors.confirmPassword }</span>) : ''}
        </div>

        <div className="form__group">
          <label className="form__label">Address</label>
          <input className="form__input" type="text" value={ formik.values.postal_address } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_address" id="postal_address" placeholder="Street address" />
          <input className="form__input" type="text" value={ formik.values.postal_code } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_code" id="postal_code" placeholder="Postal code" />
          { formik.touched.postal_code && formik.errors.postal_code ? (<span className="form__error-item">{ formik.errors.postal_code }</span>) : ''}
          <input className="form__input" type="text" value={ formik.values.postal_suburb } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_suburb" id="postal_suburb" placeholder="Suburb" />
          <div className="form__select-container">
            <select className="form__select" onChange={ formik.handleChange } value={ formik.values.postal_state } onBlur={ formik.handleBlur } name="postal_state" id="postal_state">
              {
                Object.values(States).map((state, key) => (
                  <option value={ state } key={ key }>{ state }</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className="form__group">
          <label className="form__label">Group Name</label>
          <input className="form__input" type="text" value={ formik.values.group_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="group_name" id="group_name" placeholder="Group name" />
        </div>

        {
          isAdmin ? 
          (
            <>
              <div className="form__group">
                <label htmlFor="is_admin" className="form__label">Admin privilege?</label>
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_admin } onBlur={ formik.handleBlur } name="is_admin" id="is_admin">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div className="form__group">
                <label htmlFor="is_akfstaff" className="form__label">AKF staff member?</label>
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_akfstaff } onBlur={ formik.handleBlur } name="is_akfstaff" id="is_akfstaff">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div className="form__group">
                <label htmlFor="is_licenseduser" className="form__label">Licensed user?</label>
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_licenseduser } onBlur={ formik.handleBlur } name="is_licenseduser" id="is_licenseduser">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
            </>
          ) : null
        }

        <div className="form__button-group">   
          {
            !appProps.isUserAuthenticated &&
            <span className="form__button button button--hollow" onClick={ props.recoverPasswordEvent }>Forgot password?</span>
          }
          <button type="submit" className="form__button button" disabled={ appProps.loading || !formik.dirty }>Create account</button>
        </div>
        
        {
          !appProps.isUserAuthenticated &&
          <p className="form__help-text">Already have an account? <span className="form__help-link" onClick={ props.signInEvent }>Sign in!</span></p>
        }
      </form>
    </>
  );

}

export default SignUpForm;